import { render, staticRenderFns } from "./Strategy.vue?vue&type=template&id=490d84eb&"
import script from "./Strategy.vue?vue&type=script&lang=js&"
export * from "./Strategy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports